import { apiPath } from "utils/url.js";

// utility class for ajax
// TODO fetchやaxiosで置き換える

export const xhrErrors = xhr => {
  var data = xhr.responseJSON;
  if (data !== null && typeof data === "object" && data.errors) {
    return data.errors;
  }
  return {};
};

export const xhrSummaryErrors = xhr => {
  if (xhr.status == 500) {
    return ["内部エラーが発生しました。しばらくして再実行してください。"];
  } else if (xhr.status == 403) {
    return ["権限がありません。"];
  } else if (xhr.status == 404) {
    return ["指定されたものが見つかりません。"];
  } else if (xhr.status == 400) {
    var data = xhr.responseJSON;
    if (data !== null && typeof data === "object" && data.errors) {
      let errors = [];
      for (let key in data.errors) {
        errors = errors.concat(data.errors[key]);
      }
      return errors;
    }
    return ["リクエストを実行できませんでした。"];
  } else {
    return [`エラーが発生しました。ステータス: ${xhr.status}`];
  }
};

const _execute = (opts, callbacks) => {
  $.ajax(opts)
    .done(function (data, status, xhr) {
      if (callbacks.success) {
        callbacks.success(data);
      }
    })
    .fail(function(xhr, status, error) {
      if (callbacks.error) {
        callbacks.error(xhr, status, error);
      }
    })
    .always(function(xhr, status) {
      if (callbacks.complete) {
        callbacks.complete();
      }
    });
};

const getOptions = (method, url, data) => {
  var opts = {
    method: method.toUpperCase(),
    url: apiPath(url),
    dataType: "json",
    headers: {},
    traditional: false,
  };

  let csrfToken = document.getElementById('csrf-token');
  if (["GET", "DELETE"].includes(opts.method)) {
    opts.data = data;
    opts.traditional = true;
  } else {
    opts.contentType = "application/json";
    opts.data = JSON.stringify(data);
  }
  if (["PUT", "DELETE"].includes(opts.method)) {
    opts.headers["X-HTTP-Method-Override"] = method.toUpperCase();
    opts.method = "POST";
  }
  if (opts.method === "POST") {
    opts.headers["X-CSRF-Token"] = csrfToken.getAttribute('content');
  }

  return opts;
};

export const xhrRequest = (method, url, data, callbacks) => {
  var opts = getOptions(method, url, data);
  return _execute(opts, callbacks || {});
};
